import React, { useState, useEffect } from 'react';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import {url,urlLive} from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import dayjs from 'dayjs'; 
import 'dayjs/locale/en-gb'; // Import the locale for British English


function Tables() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [vat, setVat] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [sdi, setSdi] = useState("");
  const [email, setEmail] = useState("");
  const [Active, setActive] = React.useState(true);

  const [errors, setErrors] = useState({ name: "" });

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deletecompanyId, setDeletecompanyId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editCompanyId, setEditCompanyId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission


  // Fetch companies when the component mounts

  useEffect(() => {

    // const requestOptions = {
    //   method: "GET",
    //   redirect: "follow"
    // };

    // fetch(`${url}auth/get-companies`, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     console.log(result);
    //     if (result.companies) {
    //       setCompanies(result.companies);
    //     }
    //   })
    //   .catch((error) => console.error("Error fetching companies:", error));

    getCompaines();

  }, []);


  const getCompaines = () => {
   
    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-companies`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.companies) {
          setCompanies(result.companies);
        }
      })
      .catch((error) => console.error("Error fetching companies:", error))
      .finally(() => {
        setLoading(false);  // Hide loader after fetching
      });

  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Check each field one by one and return the first error found
    if (!companyName) {
      newErrors.companyName = "Nome azienda obbligatorio";
      isValid = false;
    } else {
      newErrors.companyName = ""; // Clear the error once the field is valid
    }

    if (!vat) {
      newErrors.vat = "Partita IVA obbligatorio";
      isValid = false;
    } else {
      newErrors.vat = ""; // Clear the error once the field is valid
    }

    if (!address) {
      newErrors.address = "Indirizzo obbligatorio";
      isValid = false;
    } else {
      newErrors.address = ""; // Clear the error once the field is valid
    }

    if (!city) {
      newErrors.city = "Città obbligatorio";
      isValid = false;
    } else {
      newErrors.city = ""; // Clear the error once the field is valid
    }

    if (!state) {
      newErrors.state = "Stato obbligatorio";
      isValid = false;
    } else {
      newErrors.state = ""; // Clear the error once the field is valid
    }

    if (!sdi) {
      newErrors.sdi = "SDI obbligatorio";
      isValid = false;
    } else {
      newErrors.sdi = ""; // Clear the error once the field is valid
    }

    if (!email) {
      newErrors.email = "Email obbligatorio";
      isValid = false;
    } else {
      newErrors.email = ""; // Clear the error once the field is valid
    }

    setErrors(newErrors);
    return isValid;
  };

  
  // const handleSubmit = () => {
  //   if (validateForm()) {
  //     console.log("company added:", { companyName });
  //     setCompanyName(""); // Reset form after submission
  //     setSelectedTab(0);    // Switch back to List tab
  //   }
  // };


  const handleSubmit = () => {
    if (validateForm()) {

      setFormLoading(true);  // Show loader during form submission
      // Create a FormData object with the form data
      const formData = new FormData();
      formData.append("CompanyName", companyName);
      formData.append("Vat", vat);
      formData.append("Address", address);
      formData.append("City", city);
      formData.append("State", state);
      formData.append("Sdi", sdi);
      formData.append("Email", email);
      formData.append("is_active", (Active) ? 1 : 0);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('CreationUser', `${akLoginUser.user.IdUser}`)
      
      // Configure the POST request
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
      };
  
      // Send the POST request to create a new company
      fetch(`${url}auth/create-companies`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            // Assuming result includes the newly created company details
            // console.log(result);

            // setCompanies((prevCompanies) => [
            //   ...prevCompanies,
            //   {
            //     IdCompany: result.company.IdCompany,
            //     CompanyName: result.company.CompanyName,
            //     Vat: result.company.Vat,
            //     Address: result.company.Address,
            //     City: result.company.City,
            //     State: result.company.State,
            //     Sdi: result.company.Sdi,
            //     Email: result.company.Email,
            //     CreationDate: formatDate(result.company.CreationDate), // Assuming formatDate is a function
            //     CreationUser: result.company.CreationUser,
            //   },
            // ]);

            getCompaines();
            // Reset the form state
            setCompanyName("");
            setVat("");
            setAddress("");
            setCity("");
            setState("");
            setSdi("");
            setEmail("");
            setSelectedTab(0); // Switch back to the List tab
            console.log("Company added successfully:", result);
          } else {
            // Show error message if validation failed
            alert(`Warning: ${result.message}`);
            console.error("Error adding company:", result.message);
          }
        })
        .catch((error) => console.error("Error adding company:", error))
        .finally(() => {
          setFormLoading(false);  // Hide loader after form submission
        });

    }
  };
  

  const formatDate = (dateString) => {
    if(!dateString){
      return '';
    }    
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const columns = [
    { Header: "#", accessor: "IdCompany" },
    { Header: "Nome azienda", accessor: "CompanyName" },
    { Header: "Partita IVA", accessor: "Vat" },
    { Header: "Indirizzo", accessor: "Address" },
    { Header: "Città", accessor: "City" },
    { Header: "Stato", accessor: "State" },
    { Header: "SDI", accessor: "Sdi" },
    { Header: "Email", accessor: "Email" },
    { Header: "IdUserReferal", accessor: "IdUserReferal" },
    { Header: "Data creazione", accessor: "CreationDate" },
    { Header: "Utente creazione", accessor: "CreationUser" },
    { Header: "Utente aggiornamento", accessor: "UpdateUser" },
    { Header: "Data aggiornamento", accessor: "UpdateDate" },
    { Header: "Stato", accessor: "Status" },
    { Header: "Actions", accessor: "actions" }, // Action Column
  ];

  const rows = companies.map((company) => ({
    IdCompany: company.IdCompany,
    CompanyName: company.CompanyName,
    Vat: company.Vat,
    Address: company.Address, //Requestcompany
    City: company.City,
    State: company.State,
    Sdi: company.Sdi,
    Email: company.Email,
    IdUserReferal: company.IdUserReferal,
    // CreationDate: formatDate(company.CreationDate),
    CreationDate: company.CreationDate ? dayjs(company.CreationDate).format('DD-MM-YYYY') : '' ,
    CreationUser: company.CreationUserName,
    UpdateUser: company.UpdateUserName,
    // UpdateDate: formatDate(company.UpdateDate),
    UpdateDate: company.UpdateDate ? dayjs(company.UpdateDate).format('DD-MM-YYYY') : '' ,
    Status: (company.IsActive) ? 'Active' : 'In Active',
    actions: (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(company)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
            // backgroundColor: '#1976d2',
            backgroundColor: '#183759',
            '&:hover': { 
              // backgroundColor: '#1565c0',
              backgroundColor: '#204b80',
             },
          }}
        >
          {/* Edit */}
          Modifica
        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(company.IdCompany)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
          disabled={company.active}
        >
          {/* Delete */}
          Cancella
        </Button>
      </Box>
    ),
  }));

  const handleEditDialogOpen = (company) => {
    setCompanyName(company.CompanyName);
    setEditCompanyId(company.IdCompany);
    setVat(company.Vat);
    setAddress(company.Address);
    setCity(company.City);
    setState(company.State);
    setSdi(company.Sdi);
    setEmail(company.Email);
    setActive((company.IsActive) ? true : false);
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {
    setCompanyName("");
    setVat("");
    setAddress("");
    setCity("");
    setState("");
    setSdi("");
    setEmail("");
    setEditCompanyId(null);
    setOpenEditDialog(false);
  };

  const handleEditSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("CompanyName", companyName);
      formData.append("Vat", vat);
      formData.append("Address", address);
      formData.append("City", city);
      formData.append("State", state);
      formData.append("Sdi", sdi);
      formData.append("Email", email);
      formData.append("is_active", (Active) ? 1 : 0);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('UpdateUser', `${akLoginUser.user.IdUser}`)
      
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      fetch(`${url}auth/update-companies/${editCompanyId}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // console.log(result);
          // Update the company list after editing
          
          // setCompanies(companies.map(company =>
          //   company.IdCompany === editCompanyId
          //     ? { ...company, CompanyName: companyName, Vat: vat, Address: address, City: city, State: state, SDI: sdi, Email: email }
          //     : company
          // ));

          getCompaines();

          handleEditDialogClose();
        })
        .catch((error) => console.error("Error updating company:", error));
    }
  };

  // Open the confirmation dialog for deletion
  const handleDeleteDialogOpen = (companyId) => {
    setDeletecompanyId(companyId);
    setOpenDeleteDialog(true);
  };

  // Close the confirmation dialog without deleting
  const handleDeleteDialogClose = () => {
    setDeletecompanyId(null);
    setOpenDeleteDialog(false);
  };

  // Perform the delete action if confirmed
  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    fetch(`${url}auth/companies/${deletecompanyId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        // Refresh the company list after deletion
        setCompanies(companies.filter(company => company.IdCompany !== deletecompanyId));
        setOpenDeleteDialog(false);
      })
      .catch((error) => console.error("Error deleting company:", error));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {/* Companies */}
                  Aziende
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List company" />
                  <Tab label="Add company" /> */}

                  <Tab label="Elenco Aziende" />
                  <Tab label="Nuova azienda" />

                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      // entriesPerPage={false}
                      entriesPerPage={{defaultValue:10}}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex = {currentPageIndex}
                      setCurrentPageIndex = {setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {selectedTab === 1 && (
                  <MDBox pt={3} px={2}>
                    <MDTypography variant="h6" mb={3} align="center">
                      {/* Add New company */}
                      Aggiungi Nuova azienda
                    </MDTypography>
                    <Grid container spacing={2} justifyContent="center">

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="Company Name"
                            label="Nome azienda"
                            variant="outlined"
                            fullWidth
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            error={!!errors.companyName} // Check for specific field error
                            helperText={errors.companyName} // Show helper text for that specific error
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="Vat"
                            label="Partita IVA"
                            variant="outlined"
                            fullWidth
                            value={vat}
                            onChange={(e) => setVat(e.target.value)}
                            error={!!errors.vat}
                            helperText={errors.vat}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="Address"
                            label="Indirizzo"
                            variant="outlined"
                            fullWidth
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            error={!!errors.address}
                            helperText={errors.address}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="City"
                            label="Città"
                            variant="outlined"
                            fullWidth
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            error={!!errors.city}
                            helperText={errors.city}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="State"
                            label="Stato"
                            variant="outlined"
                            fullWidth
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            error={!!errors.state}
                            helperText={errors.state}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            label="SDI"
                            variant="outlined"
                            fullWidth
                            value={sdi}
                            onChange={(e) => setSdi(e.target.value)}
                            error={!!errors.sdi}
                            helperText={errors.sdi}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={!!errors.email}
                            helperText={errors.email}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
                          <Checkbox
                            checked={Active}
                            onChange={(e) => setActive(e.target.checked)}
                            sx={{
                              mr: 1,
                              '&.Mui-checked .MuiSvgIcon-root': {
                                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                                borderColor: '#344767',
                              },
                            }} // Adds spacing between checkbox and text
                          />
                          {/* <MDTypography variant="body2">Active</MDTypography> */}
                          <MDTypography variant="body2">Attiva</MDTypography>
                        </MDBox>
                      </Grid>


                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                              fontSize: '14px',
                              borderRadius: '8px',
                              height: '40px',
                              color: '#ffffff',
                              // '&:hover': {
                              //   backgroundColor: '#0b5ed7',
                              // },
                              backgroundColor: '#183759', // 💙 Base background color
                              '&:hover': {
                                backgroundColor: '#204b80', // ✨ Slightly lighter hover
                              },
                              
                            }}
                          >
                            {/* Add company */}
                            Salva
                          </Button>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                )}

              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Confirm Deletion</DialogTitle> */}
        <DialogTitle>Conferma l'eliminazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this company? This action cannot be undone. */}
            Sei sicuro di voler eliminare questa azienda? Questa azione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla    
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
          Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Company Confirmation Dialog */}


      <Dialog open={openEditDialog} onClose={handleEditDialogClose} fullWidth maxWidth="sm">
        {/* <DialogTitle>Edit Company</DialogTitle> */}
        <DialogTitle>Modifica azienda</DialogTitle>
        <DialogContent>
          <TextField
            // label="Company Name"
            label="Azienda"
            variant="outlined"
            fullWidth
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            error={!!errors.companyName}
            helperText={errors.companyName}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            // label="Vat"
            label="Partita IVA"
            variant="outlined"
            fullWidth
            value={vat}
            onChange={(e) => setVat(e.target.value)}
            error={!!errors.vat}
            helperText={errors.vat}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            // label="Address"
            label="Indirizzo"
            variant="outlined"
            fullWidth
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            error={!!errors.address}
            helperText={errors.address}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            // label="City"
            label="Città"
            variant="outlined"
            fullWidth
            value={city}
            onChange={(e) => setCity(e.target.value)}
            error={!!errors.city}
            helperText={errors.city}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            // label="State" 
            label="Stato"
            variant="outlined"
            fullWidth
            value={state}
            onChange={(e) => setState(e.target.value)}
            error={!!errors.state}
            helperText={errors.state}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            // label="SDI"
            label="SDI"
            variant="outlined"
            fullWidth
            value={sdi}
            onChange={(e) => setSdi(e.target.value)}
            error={!!errors.sdi}
            helperText={errors.sdi}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />

          <Grid item xs={12} md={6}>
            <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={Active}
                onChange={(e) => setActive(e.target.checked)}
                sx={{
                  mr: 1,
                  '&.Mui-checked .MuiSvgIcon-root': {
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                    borderColor: '#344767',
                  },
                }} // Adds spacing between checkbox and text
              />
              {/* <MDTypography variant="body2">Active</MDTypography>  */}
              <MDTypography variant="body2">Attiva</MDTypography>
            </MDBox>
          </Grid>


        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            {/* Cancel */}
            Annulla    
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            {/* Save */}
            Salva    
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );

}

export default Tables;
